import React, { useState, useEffect, FC, useRef } from 'react';
import styled from 'styled-components';
import { appStore } from '@store';
import { useT } from '@hooks';

interface Props {
	startTime?: number;
}

const Container = styled.div`
	background: rgba(255, 212, 0, 0.05);
	border: 2px solid #ffd400;
	border-radius: 16px;
	min-height: 121px;
	padding: 13px;
	width: 100%;
	margin-top: 20px;
`;

const Title = styled.p`
	color: ${({ theme }) => theme.colors.text1};
	font-size: 14px;
	line-height: 19px;
`;

const Timer = styled.p`
	color: ${({ theme }) => theme.colors.text14};
	display: flex;
	font-size: 14px;
	font-weight: 700;
	line-height: 19px;
	margin-top: 10px;
`;

const Description = styled.p`
	color: ${({ theme }) => theme.colors.text19};
	font-size: 12px;
	line-height: 14px;
	margin-top: 10px;
`;

export const Notification: FC<Props> = props => {
	const { startTime } = props;
	const { paymentStore } = appStore;
	const [timeLeft, setTimeLeft] = useState(startTime || 540);
	const [startTimeMin, setStartTimeMin] = useState<number>(startTime ? startTime / 60 : 540 / 60);
	const ref = useRef<HTMLParagraphElement>(null);
	const { T } = useT();

	useEffect(() => {
		if (!timeLeft) return;

		const intervalId = setInterval(() => {
			setTimeLeft(timeLeft - 1);
		}, 1000);

		return () => clearInterval(intervalId);
	}, [timeLeft]);

	const formatTime = (time: number) => {
		const minutes = Math.floor(time / 60);
		const seconds = time % 60;
		return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
	};

	function replaceNumber(text: string, newNumber: string): string {
		return text.replace(/(\d+)/, newNumber);
	}

	useEffect(() => {
		if (ref.current) {
			ref.current.innerHTML = replaceNumber(T('payment_text_6_4'), String(startTimeMin));
		}
	}, [ref.current, startTimeMin]);

	useEffect(() => {
		if (paymentStore.isShowTimer) {
			setTimeLeft(1140);
			setStartTimeMin(1140 / 60);
		}
	}, [paymentStore.isShowTimer]);

	return (
		<Container>
			<Title ref={ref}></Title>
			<Timer>
				{T('payment_text_6_5')} {formatTime(timeLeft)}
			</Timer>
			<Description>{T('payment_text_6_6')}</Description>
		</Container>
	);
};
